import { LEGAL_URLS } from "@/components/LegalLinks";

const linkClass = "text-sky-600 hover:text-sky-700 underline underline-offset-2 font-medium";

export function GdprNotice() {
  return (
    <div
      className="rounded-lg border border-slate-200 bg-slate-50 p-3 text-xs leading-relaxed text-slate-600"
      data-testid="gdpr-notice"
    >
      <p className="font-semibold text-slate-700 mb-1">Información básica sobre protección de datos</p>
      <p>
        <span className="font-medium text-slate-700">Responsable:</span> Sitayag SLU.{" "}
        <span className="font-medium text-slate-700">Finalidad:</span> gestionar el alta de usuario y el acceso a la
        plataforma.{" "}
        <span className="font-medium text-slate-700">Derechos:</span> acceso, rectificación, supresión y demás derechos
        según la política de privacidad.{" "}
        <span className="font-medium text-slate-700">Más información:</span>{" "}
        <a href={LEGAL_URLS.privacy} target="_blank" rel="noopener noreferrer" className={linkClass} data-testid="gdpr-privacy-link">
          Política de Privacidad
        </a>
        .
      </p>
    </div>
  );
}
